module.exports = __webpack_public_path__ + "static/media/flag-united-states.70091014.svg";